/**
 * Sentinel for a value that is still being loaded (e.g. an in-flight Firestore
 * snapshot). Distinct from `null`, which means "loaded, and absent".
 */
export const JC_LOADING = Symbol('JcLoading');

/**
 * The type of {@link JC_LOADING}. Data hooks return `T | JcLoading` (or
 * `T | null | JcLoading`) so consumers can distinguish loading from absent.
 */
export type JcLoading = typeof JC_LOADING;

/** Narrowing type guard: is this value the loading sentinel? */
export const isLoading = (value: unknown): value is JcLoading => value === JC_LOADING;
export const isLoadingOrNull = (value: unknown): value is JcLoading | null | undefined => value === JC_LOADING || value == null;
